import * as React from 'react';
import { useNavHeightContext } from 'common/contexts/NavHeightContext';
import styles from '../../styles/typography.module.css';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const Page: React.FC<Props> = (props) => {
  const { className, children } = props;
  const { marginTop } = useNavHeightContext();
  return (
    <div
      className={`${styles.font} bg-white overflow-auto ${className}`}
      style={{ marginTop, height: `calc(100vh - ${marginTop}px)` }}
    >
      {children}
    </div>
  );
};
Page.displayName = 'Page';
